<p-dialog
  [modal]="true"
  [style]="{ width: width }"
  [(visible)]="dialogVisible"
  (onHide)="hiddenEvent()"
  [appendTo]="appendTo"
>
  <ng-template pTemplate="header">
    <div class="tw-flex tw-items-center tw-gap-2">
      <i
        *ngIf="headerIconClass"
        [class]="headerIconClass"
      ></i>
      <span class="tw-font-semibold tw-text-xl">{{ header }}</span>
    </div>
  </ng-template>
  <ng-container *ngIf="dialogVisible">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    <div class="tw-flex tw-justify-end tw-gap-2">
      <p-button
        severity="secondary"
        [label]="secondaryBtnText"
        (onClick)="secondaryBtnEvent()"
      />
      <p-button
        *ngIf="!primaryBtnHidden"
        [severity]="primaryBtnSeverity"
        [label]="primaryBtnText"
        [disabled]="primaryBtnDisabled"
        (onClick)="primaryBtnEvent()"
      />
    </div>
  </ng-container>
</p-dialog>
